import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  portalRoot: {
    zIndex: 2000,
    position: 'fixed',
    inset: 0,
    right: 'var(--ai-chat-space, 0px)',
    pointerEvents: 'none',
  },
  notificationWrapper: {
    pointerEvents: 'auto',
  },
}));
